import { Theme } from '../utils/types';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: Theme = {
  theme: 'dark',
};

export const themeSlice = createSlice({
  name: 'themeSlice',
  initialState,
  reducers: {
    updateAppTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload.theme;
    }
  },
});

export const { updateAppTheme } =
  themeSlice.actions;

export default themeSlice.reducer;
